<template>
  <div class="section">
    <div class="container singup">
      <div class="columns is-flex-direction-column">
        <div
          id="sign-up-email"
          class="is-half-desktop is-offset-one-quarter-desktop"
        >
          <div class="title">キャスト登録</div>
          <div class="flow">
            <UserRegistrationFlow
              :userType="'performer'"
              :isAuthCompleted="isAuthCompleted"
            />
          </div>
        </div>
        <div class="created mt-2">
          <p class="is-size-7 has-text-centered">
            既にアカウントをお持ちの方は
            <router-link to="/signin">こちら</router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserRegistrationFlow from '@/components/Organisms/UserRegistrationFlow';

// TODO: FacebookやGoogleでサインアップできるように
export default {
  name: 'SignUp',
  components: {
    UserRegistrationFlow
  },
  props: {
    isAuthCompleted: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/signup.scss';
</style>
